/**
 * „Abmeldung ausstehend“: Wer sich ohne Netz abmeldet, ist lokal sofort abgemeldet, das Refresh-Cookie ist auf dem Server aber
 * noch gültig. Das Merkzeichen hält zwei Dinge fest, bis der Server-Logout nachgeholt ist (Regel 10):
 * - Keine stille Wiederanmeldung über das Cookie (`refreshSession` gibt `false` zurück, der Start prüft keine Sitzung).
 * - Der Server-Logout wird bei der nächsten Gelegenheit (Netz zurück, App-Start, vor einer neuen Anmeldung) nachgeholt.
 * Es enthält kein Token und keine Personendaten, nur den Zeitpunkt. Ohne Speicher (privates Fenster) gilt es nur im Speicher.
 */
const KEY = 'barso.auth.logoutPending';

const memory = { pending: false };

export function markLogoutPending(): void {
  memory.pending = true;
  try {
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    // ohne Speicher gilt das Zeichen nur in diesem Fenster
  }
}

export function clearLogoutPending(): void {
  memory.pending = false;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nichts zu entfernen
  }
}

export function isLogoutPending(): boolean {
  if (memory.pending) return true;
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return false;
  }
}
